<template>
  <div class="locked-option">
    <span class='btn-xs btn-danger lock-icon'><i class='fa fa-lock' title='Locked: Premium Only'/></span>
    <span class='locked-option-text'>
      {{ label }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'LockedOption',
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    }
  }
}

</script>
